import * as POIModule from 'Modules/POIModule';
import * as AOIModule from 'Modules/AOIModule';
import * as AlertModule from 'Modules/AlertModule';

export function createZonesArray(poiArray: Array<POIModule.Types.PointOfInterestDto>, aoiArray: Array<AOIModule.Types.AreaOfInterestDto>): Array<AlertModule.Types.DomainOfInterestDto> {
    const zonesArr: Array<AlertModule.Types.DomainOfInterestDto> = [];
    poiArray.forEach((e, i) => {
        zonesArr.push({
            id: e.id,
            title: e.title,
            domainOfInterestType: AlertModule.EnumTypes.DomainOfIntrestType.POI,
            address: e.address
        });
    });
    aoiArray.forEach((e, i) => {
        zonesArr.push({
            id: e.id,
            title: e.title,
            domainOfInterestType: AlertModule.EnumTypes.DomainOfIntrestType.AREA,
            address: e.address
        });
    });
    return zonesArr;
}



// WEBPACK FOOTER //
// ./src/components/Zones/ZonesHelpers.tsx